import React, {
    createContext,
    useContext,
    useRef,
    type PropsWithChildren,
    type ReactNode,
    type RefObject,
} from 'react';

type SharedRestsScreenshotContextValue = RefObject<HTMLDivElement | null>;

const SharedRestsScreenshotContext = createContext<SharedRestsScreenshotContextValue | null>(null);

export const SharedRestsScreenshotProvider = ({children}: PropsWithChildren) => {
    const targetRef = useRef<HTMLDivElement | null>(null);

    return (
        <SharedRestsScreenshotContext.Provider value={targetRef}>
            {children}
        </SharedRestsScreenshotContext.Provider>
    );
};

export const useSharedRestsScreenshotTarget = (): SharedRestsScreenshotContextValue | null => {
    return useContext(SharedRestsScreenshotContext);
};

type SharedRestsScreenshotCaptureRootProps = {
    children: ReactNode;
    className?: string;
};

export const SharedRestsScreenshotCaptureRoot = ({children, className}: SharedRestsScreenshotCaptureRootProps) => {
    const targetRef = useSharedRestsScreenshotTarget();

    if (!targetRef) {
        return <>{children}</>;
    }

    return (
        <div ref={targetRef} className={className}>
            {children}
        </div>
    );
};
